import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=77276f0a&"
import script from "./rating.vue?vue&type=script&lang=js&"
export * from "./rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77276f0a')) {
      api.createRecord('77276f0a', component.options)
    } else {
      api.reload('77276f0a', component.options)
    }
    module.hot.accept("./rating.vue?vue&type=template&id=77276f0a&", function () {
      api.rerender('77276f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/rating.vue"
export default component.exports